import { render, staticRenderFns } from "./GameDashboards.vue?vue&type=template&id=2cf5c7ae&scoped=true"
import script from "./GameDashboards.vue?vue&type=script&lang=js"
export * from "./GameDashboards.vue?vue&type=script&lang=js"
import style0 from "./GameDashboards.vue?vue&type=style&index=0&id=2cf5c7ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf5c7ae",
  null
  
)

export default component.exports